// Dashboard Color Configuration

export const dashboardColors = {
  primary: '#4A5A33',
  secondary: '#6B7B4A',
  success: '#22C55E',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#3B82F6',
  internal: '#15803D', // Darker emerald green
  external: '#D97706', // Amber, berbeda dari warning yang lebih terang
  cpo: '#15803D',
  pk: '#7C3AED',
  ck: '#EA580C',
  solar: '#0EA5E9',
  chart: [
    '#4A5A33', // Primary green
    '#22C55E', // Success green
    '#F59E0B', // Warning orange
    '#EF4444', // Error red
    '#3B82F6', // Info blue
    '#7C3AED', // Purple
    '#DC2626', // Red
    '#EA580C', // Orange
    '#0EA5E9', // Sky blue
    '#6B7B4A', // Secondary green
    '#10B981', // Emerald
    '#F97316', // Orange
  ],
} as const;

export const supplierColors: Record<string, string> = {
  PAM1: '#4A5A33',   // Hijau tua (Primary)
  LME:  '#6B7B4A',   // Hijau olive (Secondary)
  MME:  '#22C55E',   // Hijau terang (Success)
  PAM2: '#F59E0B',   // Oranye (Warning)
  VIN:  '#EF4444',   // Merah (Error)
  LKK:  '#3B82F6',   // Biru (Info)
  ABU:  '#7C3AED',   // Ungu
};

// Additional color utilities
export const getChartColor = (index: number): string => {
  return dashboardColors.chart[index % dashboardColors.chart.length];
};

export const getSourceColor = (source: string): string => {
  return source === 'Internal' ? dashboardColors.internal : dashboardColors.external;
};

export const getCpoPkColor = (source: string): string => {
  return source === 'CPO' ? dashboardColors.internal : dashboardColors.pk;
};

export const getSupplierColor = (supplier: string): string => {
  return supplierColors[supplier.toUpperCase()] || '#A3A3A3'; // Default abu-abu jika tidak ditemukan
};

export const getProductColor = (product: string): string => {
  switch (product.toLowerCase()) {
    case 'cpo':
      return dashboardColors.cpo;
    case 'pk':
    case 'kernel':
      return dashboardColors.pk;
    case 'ck':
    case 'cangkang':
      return dashboardColors.ck;
    case 'solar':
      return dashboardColors.solar;
    default:
      return dashboardColors.primary;
  }
};
